const c = "data-pui-click-code", E = "#";
export {
  c as CLICK_CODE_ATTRIBUTE_NAME,
  E as DEFAULT_HREF
};
